import * as Yup from 'yup'
import { passwordSchema } from './password.validation'

const passwordResetSchema = Yup.object().shape({
  password: passwordSchema,
  passwordConfirm: passwordSchema.oneOf([Yup.ref('password'), null], 'validation-password-match'),
})
export { passwordResetSchema }
